export default __webpack_public_path__ + "static/media/image-wps-2.e91a5a6e.jpg";